// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3NnSb","textarea":"styles_textarea__2b-EI"};